import React from 'react'
import FriendsMobileSlide from './FriendsMobileSlide'
import './friendmobile.css'

const FriendsMobile = ({friends}) => {

      if(friends.code) return 

      return (
            <div className="friends_mobile__content">
                  <FriendsMobileSlide friends={friends} />
            </div>
      )
}

export default FriendsMobile
